import { Component } from '@angular/core';

@Component({
  selector: 'app-produto-cp',
  templateUrl: './cp.component.html'
})
export class CpComponent {}
